module.exports = __webpack_public_path__ + "static/media/home-decor.d6476a20.png";